module.exports = __webpack_public_path__ + "img/xero-logo-inv-200px.8d8e35b1.png";